/* CUBE STORE - comparatore Tably
   1) sposta il tasto "Ripristina confronto" nella barra sopra la griglia;
   2) allinea lo stato dei bottoni statici nelle griglie Globo (l'app non li aggiorna);
   3) lascia spazio in fondo alla pagina quando la barra e visibile;
   4) traduce in italiano le stringhe dinamiche dell'app;
   5) nella finestra di confronto: formatta il prezzo e costruisce la riga
      fissa con titolo e prezzo che resta in alto mentre si scorre.
   Nota: nella pagina prodotto il bottone Confronta e volutamente nascosto (CSS). */
(function () {
  var STATIC_SEL = '.tably-compare-wrapper [data-tably-dynamic-toggle]';

  /* ---------- 1. tasto "Ripristina confronto" nella barra ---------- */

  function placeDialogButton() {
    var mount = document.querySelector('.tably-dynamic-explicit-dialog-button-mount');
    var target = document.querySelector('.gf-actions .gf-filter-selection');
    if (!mount || !target) return;

    var block = mount.closest('.shopify-block') || mount;
    if (block.parentElement === target) return;

    var section = block.closest('.shopify-section');
    target.insertBefore(block, target.firstChild);
    if (section) section.style.display = 'none';
  }

  /* ---------- 2. stato dei bottoni statici (griglie Globo) ---------- */

  function syncStaticButtons() {
    var statics = document.querySelectorAll(STATIC_SEL);
    if (!statics.length) return;
    if (!document.querySelector('.tably-dynamic-bar')) return;

    var selected = {};
    var removes = document.querySelectorAll('.tably-dynamic-bar__item-remove[data-product-id]');
    for (var i = 0; i < removes.length; i++) selected[removes[i].dataset.productId] = true;

    for (var j = 0; j < statics.length; j++) {
      var btn = statics[j];
      var on = !!selected[btn.dataset.productId];
      if ((btn.dataset.selected === 'true') === on) continue;

      btn.dataset.selected = on ? 'true' : 'false';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');

      var icon = btn.querySelector('.tably-dynamic-compare-button__icon');
      if (icon) {
        icon.setAttribute('data-icon-type', on ? 'text' : 'plus');
        icon.textContent = on ? '✓' : '';
      }

      var label = btn.querySelector('.tably-dynamic-compare-button__label');
      if (label) label.textContent = on ? 'Aggiunto' : 'Confronta';
    }
  }

  /* ---------- 3. spazio sotto la barra fissa ---------- */

  function padForBar() {
    if (!document.body) return;
    var bar = document.querySelector('.tably-dynamic-bar');
    var h = bar ? bar.getBoundingClientRect().height : 0;
    var want = h > 0 ? Math.round(h + 24) + 'px' : '';
    if (document.body.style.paddingBottom !== want) document.body.style.paddingBottom = want;
  }

  /* ---------- 4. traduzione ---------- */

  var DICT = [
    [/^(\d+)\s+products?\s+selected$/i, function (m) {
      return m[1] === '1' ? '1 prodotto selezionato' : m[1] + ' prodotti selezionati';
    }],
    [/^Size:\s*(.+)$/i, function (m) { return 'Taglia: ' + m[1]; }],
    [/^Add to compare$/i, 'Confronta'],
    [/^Added$/i, 'Aggiunto'],
    [/^Compare now$/i, 'Confronta ora'],
    [/^Compare products$/i, 'Confronta prodotti'],
    [/^Clear all$/i, 'Svuota'],
    [/^Remove$/i, 'Rimuovi'],
    [/^View product$/i, 'Vedi prodotto'],
    [/^All attributes$/i, 'Tutti gli attributi'],
    [/^Show only differences$/i, 'Solo le differenze'],
    [/^Restore comparison$/i, 'Ripristina confronto'],
    [/^Restore last comparison$/i, 'Ripristina ultimo confronto'],
    [/^Copy share link$/i, 'Copia link'],
    [/^Link copied$/i, 'Link copiato'],
    [/^Close$/i, 'Chiudi'],
    [/^Product added to comparison\.?$/i, 'Prodotto aggiunto al confronto.'],
    [/^Product added\. Your comparison is ready\.?$/i, 'Prodotto aggiunto. Il confronto e pronto.'],
    [/^Product removed from comparison\.?$/i, 'Prodotto rimosso dal confronto.'],
    [/^Comparison cleared\.?$/i, 'Confronto svuotato.'],
    [/^Select at least two products to compare\.?$/i, 'Seleziona almeno due prodotti da confrontare.']
  ];

  function lookup(text) {
    for (var i = 0; i < DICT.length; i++) {
      var m = text.match(DICT[i][0]);
      if (m) return typeof DICT[i][1] === 'function' ? DICT[i][1](m) : DICT[i][1];
    }
    return null;
  }

  function translateIn(root) {
    if (!root || root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentElement;
        if (!p || p.tagName === 'SCRIPT' || p.tagName === 'STYLE') return NodeFilter.FILTER_REJECT;
        return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var raw = node.nodeValue;
      var hit = lookup(raw.trim());
      if (hit) node.nodeValue = raw.replace(raw.trim(), hit);
    }
  }

  function translateAll() {
    var roots = document.querySelectorAll(
      '[class*="tably-dynamic"], [class*="tably-compare"], [id*="tably"]'
    );
    for (var i = 0; i < roots.length; i++) translateIn(roots[i]);
  }

  /* ---------- 5. finestra di confronto: prezzo e riga fissa ---------- */

  /* L'app stampa il prezzo grezzo ("7999.00") e lo tiene nascosto via CSS.
     Qui diventa "€7.999,00", come nel resto del sito. */
  function euro(value) {
    var n = parseFloat(value);
    if (!isFinite(n)) return null;
    var parts = n.toFixed(2).split('.');
    return '€' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  function formatPrices() {
    var els = document.querySelectorAll('.tably-dynamic-modal__product-price');
    for (var i = 0; i < els.length; i++) {
      var raw = els[i].textContent.trim();
      if (!raw || raw.charAt(0) === '€') continue;
      var out = euro(raw);
      if (out) els[i].textContent = out;
    }
  }

  /* Riga fissa con titolo e prezzo.
     Non si puo' fare con position:sticky sulle celle della testata: una cella
     di griglia sticky puo' muoversi solo dentro la propria riga, e la riga e'
     alta esattamente come la cella. Quindi la riga fissa e' un elemento a
     parte, inserito prima della tabella dentro il contenitore che scorre.
     Larghezza e colonne vengono copiate dalla tabella per stare allineate. */
  function buildPin() {
    var body = document.querySelector('.tably-dynamic-modal__body');
    var matrix = body && body.querySelector('.tably-dynamic-modal__matrix');
    if (!matrix) return;

    var pin = body.querySelector('.cube-cmp-pin');
    if (!pin) {
      pin = document.createElement('div');
      pin.className = 'cube-cmp-pin';
      pin.setAttribute('aria-hidden', 'true');
      pin.appendChild(document.createElement('div')).className = 'cube-cmp-pin__inner';
      body.insertBefore(pin, matrix);
    }

    var inner = pin.firstElementChild;
    var heads = matrix.querySelectorAll('.tably-dynamic-modal__product-head');
    var want = heads.length + 1; /* la prima cella copre la colonna delle etichette */

    while (inner.children.length > want) inner.removeChild(inner.lastElementChild);
    while (inner.children.length < want) {
      var cell = document.createElement('div');
      cell.className = 'cube-cmp-pin__cell';
      cell.appendChild(document.createElement('span')).className = 'cube-cmp-pin__title';
      cell.appendChild(document.createElement('span')).className = 'cube-cmp-pin__price';
      inner.appendChild(cell);
    }
    if (inner.firstElementChild) {
      inner.firstElementChild.className = 'cube-cmp-pin__cell cube-cmp-pin__cell--label';
    }

    for (var i = 0; i < heads.length; i++) {
      var target = inner.children[i + 1];
      if (!target) continue;
      var src = heads[i];
      var t = src.querySelector('.tably-dynamic-modal__product-title');
      var p = src.querySelector('.tably-dynamic-modal__product-price');
      var ct = target.querySelector('.cube-cmp-pin__title');
      var cp = target.querySelector('.cube-cmp-pin__price');
      var tv = t ? t.textContent : '';
      var pv = p ? p.textContent : '';
      if (ct && ct.textContent !== tv) ct.textContent = tv;
      if (cp && cp.textContent !== pv) cp.textContent = pv;
    }

    var cols = getComputedStyle(matrix).gridTemplateColumns;
    if (inner.style.gridTemplateColumns !== cols) inner.style.gridTemplateColumns = cols;
    var w = matrix.scrollWidth + 'px';
    if (inner.style.width !== w) inner.style.width = w;

    /* la riga compare quando titolo e prezzo veri sono usciti dallo schermo */
    var meta = matrix.querySelector('.tably-dynamic-modal__product-meta');
    if (meta) {
      pin.dataset.edge = Math.round(
        meta.getBoundingClientRect().bottom - matrix.getBoundingClientRect().top
      );
    }

    if (!body.dataset.cubePin) {
      body.dataset.cubePin = '1';
      body.addEventListener('scroll', togglePin, { passive: true });
    }
    togglePin();
  }

  function togglePin() {
    var body = document.querySelector('.tably-dynamic-modal__body');
    var pin = body && body.querySelector('.cube-cmp-pin');
    if (!pin) return;
    var edge = parseInt(pin.dataset.edge, 10);
    var on = body.scrollTop > (isFinite(edge) ? edge : 320);
    if (pin.classList.contains('is-visible') !== on) pin.classList.toggle('is-visible', on);
  }

  /* ---------- avvio ---------- */

  var queued = false;
  function run() {
    queued = false;
    placeDialogButton();
    translateAll();
    syncStaticButtons();
    padForBar();
    formatPrices();
    buildPin();
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(run);
  }

  function init() {
    run();
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
